import { transformToOccupation } from '../Occupations/OccupationsTransformers';
import { OccupationOverview, OccupationOverviewResource } from './OccupationOverview';

export const transformToOccupationOverview = (
    occupationOverviewResource: OccupationOverviewResource,
): OccupationOverview => ({
    totalAmount: occupationOverviewResource?.meta?.totalAmount || 0,
    occupations: occupationOverviewResource?.occupations?.map(transformToOccupation) || [],
});
